import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  :hover {
    box-shadow: ${({ theme }) => theme.shadows.shadow3};
    border-radius: ${({ theme }) => theme.space * 2}px;
  }
  input {
    border-radius: 8px 0 0 8px;
    :hover {
      border-color: ${({ theme }) => theme.colors.n60};
      outline: none;
      box-shadow: none;
    }
  }

  .select__control {
    border-radius: 0 8px 8px 0;
    border-left: none;
    box-shadow: none !important;
  }

  .select__control--is-focused {
    border-color: ${({ theme }) => theme.colors.n60};
  }
`;
